import { atom } from 'jotai';

import type { RecordingDialogContentProps } from '@smart-tv/components/dialog/recording-dialog';

// used to sync the recording dialog content props across different useNPVR instances
export const recordingDialogContentPropsAtom = atom<RecordingDialogContentProps | null>(null);

//this is used so NPVRSheet instances can share the same onClose callback
export const closeSheetHandlerRef: { current?: () => void } = { current: undefined };
